/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { pontosModuleName } from "../pontos/shared/data.service";
import { viagensModuleName } from "../shared/data.service";
import { PontoNavigationService } from "../pontos/shared/ponto-navigation.service";
import { configuracaoModuleName } from "../../shared/services/data.service";
import { destinosModuleName } from "../destinos/shared/data.service";
import { DestinoNavigationService } from "../destinos/shared/destino-navigation.service";
import { passageirosModuleName } from "../passageiros/shared/data.service";
import { PassageiroNavigationService } from "../passageiros/shared/passageiro-navigation.service";

@Component({
    template: require('./viagem-configuracao.component.html'),
    styles: [require('./viagem-configuracao.component.css')]
})
export class ViagemConfiguracaoComponent implements OnInit {
    module: any = viagensModuleName;
    configuracaoModule: any = configuracaoModuleName;
    pontoModule: any = pontosModuleName;
    destinoModule: any = destinosModuleName;
    passageiroModule: any = passageirosModuleName;

    constructor(
        private _pontoService: PontoNavigationService,
        private _destinoService: DestinoNavigationService,
        private _passageiroService: PassageiroNavigationService
    ) { }

    ngOnInit() {
    }

    clickItem(module: any) {
        if (module.plural === this.pontoModule.plural) {
            this._pontoService.goToList();
        } else if (module.plural === this.destinoModule.plural) {
            this._destinoService.goToList();
        } else if (module.plural === this.passageiroModule.plural) {
            this._passageiroService.goToList();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/configuracao/viagem-configuracao.component.ts
 **/